import script from "./AngularEmbedPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AngularEmbedPage.vue?vue&type=script&setup=true&lang=ts"

import "./AngularEmbedPage.vue?vue&type=style&index=0&id=53fcf7d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53fcf7d0"]])

export default __exports__